import React from 'react';
import { Spinner } from '../../components/ui';
import { userName, statusClass, statusText, deviceText } from './useUserManagement';
import UserEditForm from './UserEditForm';

// Mobile (APK) User Management — search + cards with wrapped action buttons.
export default function UserManagementMobile({ vm }) {
  const { isSuperAdmin, isSelf, filtered, loading, q, setQ, open, openAdd, openEdit, softDelete, toggleActive, resetDevice } = vm;

  if (!isSuperAdmin) {
    return (
      <div>
        <div className="page-head"><h1>User Management</h1></div>
        <div className="card card-pad empty">Only Super Admin can manage all users.</div>
      </div>
    );
  }

  return (
    <div>
      <div className="mobile-toolbar">
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <strong style={{ fontSize: 16 }}>Users</strong>
          <span className="muted" style={{ fontSize: 12 }}>{filtered.length}</span>
          <div style={{ flex: 1 }} />
          <button className="btn primary sm" onClick={openAdd}>+ Add User</button>
        </div>
        <input placeholder="Search users..." value={q} onChange={(e) => setQ(e.target.value)}
          style={{ padding: '11px 12px', border: '1px solid var(--line)', borderRadius: 10 }} />
      </div>

      {loading ? <div className="card card-pad"><Spinner /></div> : filtered.length === 0 ? (
        <div className="card card-pad empty">No users found.</div>
      ) : (
        <div className="mobile-card-list">
          {filtered.map(row => (
            <div key={row.UserId} className="card card-pad mobile-record-card row-link" onClick={() => openEdit(row)}>
              <div className="mobile-card-head">
                <div style={{ minWidth: 0 }}>
                  <strong className="mobile-title">{userName(row)}</strong>
                  <div className="muted" style={{ fontSize: 12 }}>#{row.UserId}{row.FatherHusband ? ` · ${row.FatherHusband}` : ''}</div>
                </div>
                <div style={{ flex: 1 }} />
                {row.SuperAdmin === 1 ? <span className="chip male">Super Admin</span> : <span className={statusClass(row)}>{statusText(row)}</span>}
              </div>
              <div className="mobile-meta">
                <div>📞 {row.MobileNumber || '-'}{row.EmailId ? ` · ${row.EmailId}` : ''}</div>
                <div className="muted">Device: {deviceText(row)}{row.DeviceModel ? ` (${row.DeviceModel})` : ''}</div>
              </div>
              <div className="mobile-actions" onClick={(e) => e.stopPropagation()}>
                <button className="btn light sm" onClick={() => openEdit(row)}>Edit</button>
                {(row.MobileDeviceId || row.DeviceName) && <button className="btn light sm" onClick={() => resetDevice(row)}>Reset Device</button>}
                <button className="btn light sm" disabled={isSelf(row)} onClick={() => toggleActive(row)}>{row.IsActive === 0 ? 'Activate' : 'Deactivate'}</button>
                <button className="btn danger sm" disabled={isSelf(row)} onClick={() => softDelete(row)}>Remove</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {open && <UserEditForm vm={vm} />}
    </div>
  );
}
